export enum WalletWithdrawalActionType {
  SEND_ACTION = 'send',
}

export class WalletWithdrawalModel {
  code = ''
  address = ''
  amount = 0
  action = WalletWithdrawalActionType.SEND_ACTION
}

export interface IChatsWalletRequest {
  code: string
  params: string
}
